export default __webpack_public_path__ + "static/illustration_mapping_engine-fcf04020c0c11be6885f8e017d62099d.png";